<template>
  <v-list>
    <v-subheader class="h2Header secondary300 mb-3">
      {{ label }}
    </v-subheader>
    <v-list-item-group
      v-model="selectedTag"
      color="primary"
      style="height: 400px; overflow: auto;"
      class="custom-scroll"
    >
      <v-list-item
        v-for="(item) in tags"
        :key="item.key"
      >
        <v-list-item-content class="py-2">
          <v-list-item-title
            class="secondary300 text2 nunitoSansFont"
            style="white-space: normal"
            v-text="item.value"
          />
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
export default {
  name: 'ListTags',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: 'Tags gerais',
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    selectedTag: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('tag', this.tags[value]);
        this.$emit('input', value);
      },
    },
    tags() {
      return this.items;
    },
  },
};
</script>

<style scoped>
.custom-scroll::-webkit-scrollbar {
    width: 3px;
  }
  .custom-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  .custom-scroll::-webkit-scrollbar-thumb {
    background: #a91314;
    border-radius: 24px;
  }
  .custom-scroll::-webkit-scrollbar-thumb:hover {
    background: #8f0f0f;
  }
</style>
